import React from 'react';
import { Grid } from '@mui/material';
import { NotesInput } from 'app/components';
import { StoreActions, StoreSelectors, useStoreDispatch, useStoreSelector } from 'app/store';
import { actions as NotesActions } from '../../Ducks/Notes.duck';
import type { Connection } from '../../../../types';

type ConnectionNoteInputProps = {
  connectionId: Connection['connectionId'];
};

export const ConnectionNoteInput = ({ connectionId }: ConnectionNoteInputProps) => {
  const dispatch = useStoreDispatch();

  const {
    loading,
    note,
    connectionId: storeConnectionId,
  } = useStoreSelector(state => StoreSelectors.NotesSelector.selectConnectionNote(state.NotesReducer));

  React.useEffect(() => {
    if (connectionId && storeConnectionId !== connectionId) {
      dispatch(StoreActions.NotesActions.setConnectionId(connectionId));
      dispatch(StoreActions.NotesActions.requestData());
    }
  }, [connectionId, dispatch, storeConnectionId]);

  const saveNote = React.useCallback(
    (text: string) => {
      const validUpdate = note.noteId ? true : text.trim().length > 0;
      if (!loading && validUpdate) {
        dispatch(NotesActions.changeNote({ ...note, connectionId, text }));
      }
    },
    [connectionId, dispatch, loading, note],
  );

  // Uncomment this if you want to add again that only the user that created the note can actually edit it
  // const userCanEdit = (authorId) => authorId === user.userId
  const userCanEdit = (authorId: string) => true;
  const isNotAllowed = note && note.userId ? !userCanEdit(note.userId) : false;

  return (
    <Grid container spacing={0}>
      <Grid item xs={12}>
        <NotesInput
          isLoading={loading}
          isNotAllowed={isNotAllowed}
          inputValue={note.text || ''}
          onSaveNote={saveNote}
        />
      </Grid>
    </Grid>
  );
};
